'use strict';

/** Follows an item's position and toggles classes as it enters the screen.
 *
 * @param options
 * enterLength  : integer  % distance of the top of the element from the bottom of the window.
 * leaveLength  : integer  % distance of the bottom of the element from the top of the window.
 * comingClass  : string   The class to add before the element enters the screen (on page load).
 * enterClass   : string   The class to add the moment the element enters the screen.
 * leaveClass   : string   The class to add the moment the element leaves the screen (is scrolled up).
 * onlyEnter    : bool     When 'true' the plugin adds comingClass and enterClass once and stops there (only detects the first entrance of the element).
 * onlyOnce     : bool     When 'true' the plugin adds comingClass, enterClass and leaveClass and stops there.
 *
 * With both onlyEnter and onlyOnce set to false the plugin will keep toggling the classes on every scroll up or down.
 *
 */

$.fn.detectScroll = function (options) {

    const opt = $.extend({
        founder: this,
        element: '',
        page: true,
        breakpoint: true,
        enterLength: 0,
        leaveLength: 0,
        comingClass: 'is-coming',
        visibleClass: 'is-visible',
        leaveClass: 'is-gone',
        invisibleClass: 'is-invisible',
        onlyEnter: false,
        onlyOnce: false
    }, options);

    const enterLength = opt.enterLength * $(window).height() / 100;
    const leaveLength = opt.leaveLength * $(window).height() / 100;

    const app = {

        init: () => {

            // if this page is true and if this breakpoint is true
            if ( opt.page && opt.breakpoint ) {

                if ( opt.element ) {
                    app.loop( opt.element );
                } else {
                    app.loop( opt.founder );
                }
            }

        },

        loop: ($loopElement) => {

            $loopElement.each( function(index, item) {

                app.action( $(item) );

            });
        },

        // Helper function that checks the position of the element.
        position: ($element) => {
            let windowHeight = $(window).height();
            let windowTopPosition = $(window).scrollTop();
            let windowBottomPosition = windowTopPosition + windowHeight;

            let elementHeight = $element.outerHeight();
            let elementTopPosition = $element.offset().top;
            let elementBottomPosition = elementTopPosition + elementHeight;
            if (elementBottomPosition <= windowTopPosition + leaveLength) {
                return 'after';
            }
            if (elementTopPosition <= windowBottomPosition - enterLength && elementBottomPosition > windowTopPosition + leaveLength) {
                return 'visible';
            }
            if (elementTopPosition > windowBottomPosition - enterLength ) {
                return 'before';
            }
        },

        toggleClass: ( $currentItem ) => {
            if ( app.position($currentItem) === 'before' ) {
                $currentItem.addClass(opt.comingClass + ' ' + opt.invisibleClass).removeClass(opt.visibleClass + ' ' + opt.leaveClass);
            }
            if ( app.position($currentItem) === 'visible' ) {
                $currentItem.addClass(opt.visibleClass).removeClass(opt.comingClass + ' ' + opt.leaveClass + ' ' + opt.invisibleClass);
            }
            if ( app.position($currentItem) === 'after' ) {
                $currentItem.addClass(opt.leaveClass + ' ' + opt.invisibleClass).removeClass(opt.comingClass + ' ' + opt.visibleClass);
            }
        },

        action: ( $currentItem ) => {

            $(window).on('scroll', function() {
                app.toggleClass($currentItem);
            });

        }

    };

    app.init();

};
